// custom-image-text-swiper.js
(function() {
  'use strict';

  class ImageTextSwiper {
    constructor(container) {
      this.container = container;
      this.swiper = null;
      this.observer = null;
      this.sectionId = container.dataset.sectionId;
      
      this.init();
      this.initMobileRatios();
    }

    init() {
      if (!this.container) return;

      if (this.container.swiper) {
        this.swiper = this.container.swiper;
        return;
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.swiper) {
              this.createSwiper();
              this.observer.disconnect();
            }
          });
        }, {
          rootMargin: '200px',
          threshold: 0.01,
        });
        this.observer.observe(this.container);
      } else {
        this.createSwiper();
      }
    }

    initMobileRatios() {
      const handleRatios = () => {
        if (window.innerWidth > 767) return;
        
        this.container.querySelectorAll('.image-container.ratio-custom').forEach(container => {
          const mobileRatio = container.getAttribute('data-mobile-ratio');
          if (mobileRatio) {
            container.style.setProperty('--custom-ratio', mobileRatio + '%');
          }
        });
      };
      
      handleRatios();
      
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleRatios, 200);
      });
    }

    createSwiper() {
      if (!this.container || this.swiper) return;

      if (typeof Swiper === 'undefined') {
        console.warn('⚠️ Swiper library not loaded');
        return;
      }

      this._buildSwiper();
    }

    _buildSwiper() {
      const el = this.container;
      
      // 从 data-* 读取配置
      const getData = (key, fallback) => {
        const value = el.dataset[key];
        if (value === undefined || value === '') return fallback;
        if (value === 'true') return true;
        if (value === 'false') return false;
        if (!isNaN(value) && value.trim() !== '') return Number(value);
        return value;
      };

      // ✅ 关键修复：在容器内部查找元素（而不是全局查找）
      const paginationEl = el.querySelector('.swiper-pagination');
      const prevEl = el.querySelector('.custom-arrow-prev');
      const nextEl = el.querySelector('.custom-arrow-next');

      const config = {
        slidesPerView: getData('slidesPerView', 1),
        spaceBetween: getData('spaceBetween', 24),
        loop: getData('enableLoop', false),
        autoplay: getData('enableAutoplay', false) ? {
          delay: getData('autoplayDelay', 5000),
          disableOnInteraction: false,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: getData('slidesPerViewTablet', 1),
            spaceBetween: getData('spaceBetweenTablet', 20),
          },
          1024: {
            slidesPerView: getData('slidesPerViewDesktop', 1),
            spaceBetween: getData('spaceBetweenDesktop', 30),
          }
        }
      };

      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      if (prevEl && nextEl) {
        config.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }

      this.swiper = new Swiper(el, config);
      el.swiper = this.swiper;
      
      console.log('✅ ImageTextSwiper initialized');
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
        if (this.container) {
          this.container.swiper = null;
        }
      }
    }
  }

  // ============================================================
  // 自动初始化所有实例
  // ============================================================
  function initAllSliders() {
    const containers = document.querySelectorAll('.image-text-row .swiper[data-section-id]');
    
    containers.forEach(container => {
      if (container._swiperInstance) return;
      container._swiperInstance = new ImageTextSwiper(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // ============================================================
  // Shopify 事件处理
  // ============================================================
  document.addEventListener('shopify:section:unload', function(e) {
    const container = document.querySelector(`.image-text-row .swiper[data-section-id="${e.detail.sectionId}"]`);
    if (container && container._swiperInstance) {
      container._swiperInstance.destroy();
      delete container._swiperInstance;
    }
  });

  document.addEventListener('shopify:section:load', function(e) {
    const container = document.querySelector(`.image-text-row .swiper[data-section-id="${e.detail.sectionId}"]`);
    if (container && !container._swiperInstance) {
      container._swiperInstance = new ImageTextSwiper(container);
    }
  });

})();